import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import { withLocalePrefix } from 'shared/utils/translation';
import { PageName, SCORECARD_POSITIVE_RATING } from '../../shared/types';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import ExcludeStrongNoScoresCheckbox from '../checkboxes/exclude_strong_no_scores_checkbox';
import ExcludeHiredCheckbox from '../checkboxes/exclude_hired_checkbox';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';

type Props = {
  pageName: PageName;
  helperText?: string;
  hideCheckboxes?: boolean;
};

const ScorecardPerformanceDropdown = ({
  pageName,
  helperText,
  hideCheckboxes,
}: Props) => {
  const t = withLocalePrefix(`talent_${pageName}.scorecard_performance`);

  const { watch, setValue } = useFormContext();
  const selectedPerformance: Item | null = watch('scorecard_performance');

  const options: Item[] = Object.keys(SCORECARD_POSITIVE_RATING).map(
    (filterName) => ({
      label: t(`options.${filterName.toLowerCase()}`),
      value:
        SCORECARD_POSITIVE_RATING[
          filterName as keyof typeof SCORECARD_POSITIVE_RATING
        ],
    })
  );

  return (
    <Stack>
      <SimpleSingleDropdown
        label={t('label')}
        items={options}
        selectedItem={selectedPerformance}
        onSelectedItemChange={(val) =>
          setValue('scorecard_performance', val, { shouldDirty: true })
        }
        clearable={true}
        helperText={helperText}
      />
      {!hideCheckboxes && (
        <Grid sx={{ marginLeft: 2 }}>
          <ExcludeStrongNoScoresCheckbox pageName={pageName} />
          <ExcludeHiredCheckbox pageName={pageName} />
        </Grid>
      )}
    </Stack>
  );
};

export default ScorecardPerformanceDropdown;
